define('supplierImprintTechnologiesView',[
    'module',
    'underscore',
    'app',
    'settings',
    'backbone',
    'tableView',
    'tableDynamicTextFieldView',
    'entities/admin/imprint_technologies',
    'entities/suppliers/imprint_technologies',
    'supplierImprintTechnologiesCreateEditView',
    'supplierImprintTechnologiesFiltersView'
], function (
    Module,
    _,
    App,
    Settings,
    Backbone,
    TableView,
    TableDynamicTextFieldView,
    ImprintTechnologies,
    SupplierImprintTechnologies,
    CreateEditLayoutView,
    FiltersView
) {
    'use strict';

    Module.exports = TableView.extend({

        className: 'suppliers-imprint-technologies-view table-view',
        pageSize: 50,
        pageMode: 'pagination',
        footerMaxPages: 10,
        showPaginator: true,
        count: 0,
        pageCount: 0,
        filtersViewClass: FiltersView,

        init: function() {
            this.count = 0;
            this.pageCount = 0;
        },

        setFields: function() {
            return [{
                name: 'Code',
                label: _.i18n('common.code'),
                className: 'code',
                bind: 'code'
            },
                {
                    name: 'Supplier',
                    label: _.i18n('product.supplier'),
                    className: 'supplier',
                    bind: 'supplier',
                    modelEvent: 'change:supplier'
                },
                {
                    name: 'name',
                    label: _.i18n('common.name'),
                    className: 'name',
                    bind: 'name',
                    value: 'name',
                    view: TableDynamicTextFieldView,
                    modelEvent: 'change:name'
                },
                {
                    name: 'colorModeType',
                    label: _.i18n('imprintTechnology.colorModeType'),
                    className: 'ColorModeType',
                    bind: 'colorModeType',
                    modelEvent: 'change:colorModeType'
                },
                {
                    name: 'maxNumberOfColors',
                    label: _.i18n('imprintTechnology.maxNumberOfColors'),
                    className: 'MaxNumberOfColors',
                    bind: 'maxNumberOfColors',
                    modelEvent: 'change:maxNumberOfColors'
                }
            ];
        },

        fetch: function(first, pageSize, sortField, sortDirection, filters) {

            var defer = $.Deferred();

            var params = this.getFiltersParams(filters);
            params.page = Math.ceil(first/pageSize);
            params.size = pageSize;

            if (sortField !== '') {
                var sortParamName = '';
                if (sortField === 'Date')
                    sortParamName = 'notification.creatDate';

                if (sortParamName !== '') {
                    params.sidx = sortParamName;
                    params.sord = sortDirection;
                }
            }

            var url = App.request('imprint-technologies:supplier-its-get-url', params);

            if(this.fetchRequest)
                this.fetchRequest.abort();

            this.fetchRequest = $.ajax({
                type: 'GET',
                url: url,
                success: _.bind(function (items) {

                    var models = (items && items.content) ? items.content : [];
                    var total = (items && items.totalElements !== null) ? items.totalElements : undefined;

                    // Keep local count for fetchCount()
                    this.count = total || 0;

                    defer.resolve(models, total);
                }, this),
                error: function() {
                    defer.resolve([]);
                }
            });

            return defer.promise();
        },

        fetchCount: function() {
            var defer = $.Deferred();
            defer.resolve(this.count);
            return defer.promise();
        },

        onRowDoubleClick: function(rowView) {
            var model = rowView.model;

            if (model) {
                // Create a proper SupplierImprintTechnology model with the row data
                var sITModel = App.request('supplier-imprint-technologies:model', model.toJSON());
                console.log('onRowDoubleClick', model, sITModel);

                var createEditView = new CreateEditLayoutView({
                    itModel: sITModel,
                    newItem: false
                });
                createEditView.show({
                    title: _.i18n('common.edit')
                });
                createEditView.listenTo(createEditView, 'saved', _.bind(function () {
                    this.reload();
                }, this));
            }
        },

        getFiltersParams: function(filters) {
            var params = {};

            _.each(filters.attributes, function (value, key) {
                if(value !== '')
                    params[key] = value;
            }, this);

            return params;
        }
    });
});
